module.exports = __webpack_public_path__ + "static/img/moneyroad_blue.dda3bdd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/images/logo/moneyroad_blue.svg
// module id = 1484
// module chunks = 2